import React from "react";
import { Hero } from "../../components/header/header";
import { Link } from "react-router-dom";

function Links() {
  const pageTitle = "Links";
  document.title = global.AppName + " - " + pageTitle;
  return (
    <>
      <Hero
        title={"Tanning Leather"}
        subtitle={"Links and Resources"}
      ></Hero>

      {/* start main */}
      <div className="main_bg">
        <div className="wrap">
          <div className="main">
            <h2>Links</h2>
            <ul>
              <li>
                <Link to="https://braintan.com/product-category/kitchen-table-tannery/" title="" target="_blank">Traditional Tanners - Kitchen Table Tannery Zoom Classes</Link>
              </li>
              <li>
                <Link to="https://www.youtube.com/playlist?list=PL60FnyEY-eJChUzoIGCqYE20rpjbfOgfc" title="SkillCult - Home Tanning Skills, Skins and Hides Into Leather" target="_blank">SkillCult - Home Tanning Skills, Skins and Hides Into Leather</Link>
              </li>
              <li>
                <Link to="https://www.youtube.com/playlist?list=PL60FnyEY-eJA7D2FJhI5AvWVx7oqjb4xX" title="SkillCult - Tanning and Leather" target="_blank">SkillCult - Tanning and Leather</Link>
              </li>
              <li>
                <Link to="https://www.youtube.com/playlist?list=PL60FnyEY-eJBsE5mbHhW2gQMILnndQN9o" title="SkillCult - Tanning Sheepskins Series" target="_blank">SkillCult - Tanning Sheepskins Series</Link>
              </li>
              <li>
                <Link to="" title="" target="_blank"></Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default Links;
